import { Box } from '@mui/material';
import Lottie from 'react-lottie';

const DEFAULT_ANIMATION_OPTIONS = {
  loop: true,
  autoplay: true,
  animationData: require('./loader.json'),
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const LoaderAnimation = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      position="fixed"
      top={0}
      bottom={0}
      left={0}
      right={0}
      zIndex={10000}
    >
      <Lottie
        options={DEFAULT_ANIMATION_OPTIONS}
        width={180}
        height={180}
        isClickToPauseDisabled
        ariaRole="animation"
      />
    </Box>
  );
};

export default LoaderAnimation;
